export enum AppRoute {
  Login = '/login',
  Index = '/',
  Employee = '/employees',
  Department = '/departments',
  Location = '/locations',
  ExpenseCode = '/expense-codes',
  CostCenter = '/cost-centers',
  Allowance = '/allowances',
  Subscription = '/subscriptions',
  Report = '/reports',
  ForgotPassword = '/forgot-password',
  SetPassword = '/set-password',
  UpgradeAccount = '/upgrade-account',
  GiftCard = '/gift-card',
  TwoFactorAuth = '/two-factor-auth'
}

export type AppRouteId = keyof typeof AppRoute | 'Company' | 'Vouchers';
